import { Box, styled } from "@mui/material";

import {
    COLORS,
    MAIN_MAX_WIDTH,
    RADIUS,
    SHADOW,
    TYPOGRAPHY,
} from "../../SignalWizard.constants";

export const Footer = styled("footer")(({ theme }) => ({
    position: "sticky",
    bottom: 0,
    zIndex: 40,
    width: "100%",
    padding: "14px 16px",
    paddingBottom: "max(14px, env(safe-area-inset-bottom, 0px))",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(12px)",
    borderTop: `1px solid rgba(198, 198, 205, 0.3)`,
    boxShadow: SHADOW.footer,
    [theme.breakpoints.up("md")]: {
        padding: "14px 24px",
    },
}));

export const FooterInner = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "1fr",
    justifyItems: "center",
    alignItems: "center",
    rowGap: 12,
    width: "100%",
    maxWidth: MAIN_MAX_WIDTH,
    margin: "0 auto",
    // Equal side tracks keep the status on the horizontal center even when
    // the back and continue buttons change width between steps.
    [theme.breakpoints.up("sm")]: {
        gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr)",
        columnGap: 16,
        "& > :nth-of-type(1)": { justifySelf: "start" },
        "& > :nth-of-type(3)": { justifySelf: "end" },
    },
}));

/** Always occupies the center track so the status never shifts between steps. */
export const StatusSlot = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
        "&:empty": { display: "none" },
    },
}));

export const StatusPill = styled(Box)({
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "4px 12px",
    borderRadius: RADIUS.full,
    backgroundColor: COLORS.surfaceLow,
    border: `1px solid ${COLORS.border}`,
    color: COLORS.onSurface,
    whiteSpace: "nowrap",
    fontVariantNumeric: "tabular-nums",
    ...TYPOGRAPHY.labelSm,
});

export const Actions = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: 10,
    [theme.breakpoints.down("sm")]: {
        "&:empty": { display: "none" },
    },
}));
